import React, { useRef } from 'react';
import { useRouteMatch, Switch, useHistory, Route, Redirect } from 'react-router-dom';
import store from 'store';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import { Persist } from 'formik-persist';
import useScreeningData from '../../../../containers/hooks/useScreeningData';
import { getMobilesignUpTakeHealthScreeningRoutes } from '../../../../routes/mobile/signUpTakeHealthScreeningRoutes';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import TakeHealthNavBtn from '../../../../components/mobile/sign-up/TakeHealthNavBtn';
import { postHealthScreeningGuestAPICall } from '../../../../api/medical-history';
import { errorNotification } from '../../../../utils/notification-helpers';
import { LOCAL_STORAGE_AUTH_KEY,MENTAL_HEALTH_CATEGORY_REF_HEALTH_SCREENING_KEY } from '../../../../config/constants';

const TakeHealthScreeningWrapper = ({prevRoutePath, children, ...restNavBtnProps }) => (
  <>
    {children}
    <TakeHealthNavBtn prevRoutePath={prevRoutePath} {...restNavBtnProps} />
  </>
);

function MobileTakeHealthScreeningScreen() {
  const { t } = useTranslation(['common', 'speak-doctor']);
  const match = useRouteMatch();
  const history = useHistory();
  const ref = useRef(null);

  const { path } = match;
  const { setScreeningData } = useScreeningData();

  const initialValues = {
    allergies: '',
    medical_conditions: '',
    medications: '',
    family_history: '',
    measurements: null
  };

  const validateScreeningData = (values) => {
    const {allergies} = values
    // eslint-disable-next-line camelcase
    const {medical_conditions} = values
    const {medications} = values
    // eslint-disable-next-line camelcase
    const {family_history} = values
    const {measurements} = values

    if (allergies.length === 0) {
      return false;
    }

    if (medical_conditions.length === 0) {
      return false;
    }

    if (medications.length === 0) {
      return false;
    }

    if (family_history.length === 0) {
      return false;
    }

    if (measurements === null && (measurements.height === undefined && measurements.height.number === undefined) &&
    (measurements.weight === undefined && measurements.weight.number === undefined)
    ) {
      return false;
    }

    return true;
  };

  const renderRoutes = (routes, total = routes.length) =>
    routes.map(({ id: count, path: p, component: Component, props: componentProps }) => {
      const {
        nextRoutePath,
        prevRoutePath,
        step,
        fieldName
      } = componentProps;

      // if(employeeStatus.covid_screening_done){
      //   return <Redirect to={{ pathname: '/welcome/status' }} />
      // }

      return (
        <Route key={p} path={p}>
          <TakeHealthScreeningWrapper
            isLast={componentProps.isLastQuestion}
            nextRoutePath={nextRoutePath}
            prevRoutePath={prevRoutePath}
            fieldName={fieldName}
          >
            <Component fieldName={fieldName} step={step} count={6} />
          </TakeHealthScreeningWrapper>
        </Route>
      );
    });

  return (
    <>
      <Formik
        innerRef={ref}
        enableReinitialize
        initialValues={initialValues}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          const data = { ...values };
          const isValid = validateScreeningData(data);
          if (!isValid) {
            errorNotification(t('common:form.error.submit'));
            setSubmitting(false);
          } else {
            try {
              const { responseOk } = await postHealthScreeningGuestAPICall({
                "data": data,
                "medicle_category_ref": MENTAL_HEALTH_CATEGORY_REF_HEALTH_SCREENING_KEY
              });
              if (responseOk) {
                setSubmitting(false);
                resetForm({ values: initialValues });
                const guestId = store.get(LOCAL_STORAGE_AUTH_KEY.FAMILY_PROFILE_SIGNUP);
                if (guestId !== undefined) {
                  history.push('/sign-up/guest/add-family-member');
                } else {
                  history.push(`/sign-up/guest/thank-you`);
                }
              } else {
                errorNotification(t('common:form.error.submit'));
                setSubmitting(false);
              }
            } catch (err) {
              console.error(err);
              errorNotification(t('common:form.error.submit'));
              setSubmitting(false);
              resetForm({ values: initialValues });
            }
          }
        }}
      >
        {({ isSubmitting }) => (
          <Form loading={isSubmitting.toString()}>
            <>
              {isSubmitting}
              <Switch>
                {renderRoutes(
                  getMobilesignUpTakeHealthScreeningRoutes(),
                  getMobilesignUpTakeHealthScreeningRoutes().length - 1
                )}
                <Redirect to={`${path}/screening-request/allergies`} />
              </Switch>
            </>
            {!isSubmitting && <Persist name="health-screening-form" />}
            {isSubmitting ? (
              <LoadingSpinner position="full" transparent={false} />
            ) : null}
          </Form>
        )}
      </Formik>
    </>
  );
}

export default MobileTakeHealthScreeningScreen;
